export default __webpack_public_path__ + "static/media/prosper-work-life.1e3a6ea7.svg";